import helpers from '@/router/helpers';
import UserRoles from '@/constants/user/roles';

export default {
    path: '/mail/search',
    meta: {
        title: 'Search',
        documentTitle: 'Mail Search',
        requiresAuth: true,
        mdiIcon: 'magnify',
        allowedRoles: [
            UserRoles.SUPER_ADMIN,
            UserRoles.MAIL_OPERATOR,
        ],
    },
    component: helpers.getRouterView(),
    children: [
        {
            path: '',
            name: 'MailSearch',
            meta: {
                title: 'Search',
                documentTitle: 'Mail Search',
                shouldPersistBetweenLogins: true,
                allowedRoles: [
                    UserRoles.SUPER_ADMIN,
                    UserRoles.MAIL_OPERATOR,
                ],
            },
            component: () => import( /* webpackChunkName: "MailSearch" */ '@/views/mail/Search' ),
        },
        {
            path: 'detail',
            redirect: '/mail/search',
            meta: {
                title: 'Tracking History',
                documentTitle: 'Tracking History',
            },
        },
        {
            path: 'detail/:id',
            meta: {
                title: 'Tracking History',
                documentTitle: 'Tracking History',
            },
            component: helpers.getRouterView(),
            children: [
                {
                    path: '',
                    name: 'MailSearchDetail',
                    meta: {
                        title: 'Tracking History',
                        documentTitle: 'Tracking History',
                    },
                    component: () => import( /* webpackChunkName: "MailSearchDetail" */ '@/views/mail/search/SearchDetail' ),
                },
            ],
        },
    ],
};
